import Icon from "@mui/material/Icon";
import { ASSETS_BASE_URL } from "../../constants";

function HintIcon({ step }) {
  if (!step) {
    return null;
  }
  return (
    <Icon>
      <img
        src={`${ASSETS_BASE_URL}/image/onboarding-img/${step.icon}.svg`}
        alt={step.title}
      />
    </Icon>
  );
}

export default HintIcon;